// Just some common phrases to use in modal messaging for errors
export const SOMETHING_WENT_WRONG = 'Something went wrong.';
export const REFRESH = 'Please refresh and try again.';
export const HAPPENS_AGAIN = 'If this happens again, please contact customer service for support.';
export const SERVER_ERROR = 'We encountered an error with our servers.';
export const APOLOGIZE = 'We apologize for the inconvenience.';
export const TRY_AND_CONTACT = 'Please try again, and contact us if this reoccurs.';
export const ERROR_CONTACT = 'Contact us if you believe you received this message in error.';
